import type { OutreachEditorRef } from '@recruit-robin/robin-theme/web-components';
import type { Outreach } from 'clients/OutreachTemplateclient/OutreachTemplateClient.types';
import type { Candidate } from 'model/Candidate/Candidate';
import type { IndeedJob } from 'shared/legacy/hooks/useBrowserExtension/indeed/indeed.types';
import type { IndeedProject } from 'shared/legacy/hooks/useBrowserExtension/indeed/useIndeedProjectListQuery';
import type { OutreachModalErrorType } from '../hooks/useOutreachModalErrors';

import { OutreachPanelPage } from 'components/ui/organisms/OutreachPanel/utils/OutreachPanelPage';
import { OutreachType } from 'types/outreach';
import { createContext } from 'use-context-selector';
import { notImplemented } from 'utils/notImplemented';

export type OutreachPanelPageInfo = {
  contact?: 'success' | 'unsuccess';
  outreach: {
    werknl: {
      email: string;
      phone: string;
      website: string;
    };
  };
};

export type OutreachModalContextState = {
  candidate: Candidate;
  unSubmitedLabels: string[];
  setUnSubmitedLabels: React.Dispatch<React.SetStateAction<string[]>>;
  type: OutreachType;
  refs: {
    subject: OutreachEditorRef | null;
    message: OutreachEditorRef | null;
    setSubject: React.Dispatch<React.SetStateAction<OutreachEditorRef | null>>;
    setMessage: React.Dispatch<React.SetStateAction<OutreachEditorRef | null>>;
  };
  page: OutreachPanelPage;
  setPage: React.Dispatch<React.SetStateAction<OutreachPanelPage>>;
  pageInfo: OutreachPanelPageInfo;
  setPageInfo: React.Dispatch<React.SetStateAction<OutreachPanelPageInfo>>;
  selectedTemplate: Outreach | null;
  setSelectedTemplate: React.Dispatch<React.SetStateAction<Outreach | null>>;
  selectedIndeedProject: IndeedProject | null;
  selectedIndeedJob: IndeedJob | null;
  setSelectedIndeedProject: React.Dispatch<React.SetStateAction<IndeedProject | null>>;
  setSelectedIndeedJob: React.Dispatch<React.SetStateAction<IndeedJob | null>>;
  isIndeedReply: boolean;
  errors: OutreachModalErrorType[];
  setErrors: React.Dispatch<React.SetStateAction<OutreachModalErrorType[]>>;

  attachments: File[];
  setAttachments: React.Dispatch<React.SetStateAction<File[]>>;

  onSendMessage: () => Promise<void>;
  onContactSuccesful: () => Promise<void>;
  onContactUnsuccessful: () => Promise<void>;

  onRequestChangeType: (type: OutreachType) => void;
};

export const initialState: OutreachModalContextState = {
  unSubmitedLabels: [],
  setUnSubmitedLabels: notImplemented,
  candidate: null as any,
  page: OutreachPanelPage.Outreach,
  setPage: notImplemented,
  refs: {
    subject: null,
    message: null,
    setMessage: notImplemented,
    setSubject: notImplemented,
  },
  type: OutreachType.Email,
  pageInfo: {
    contact: undefined,
    outreach: {
      werknl: {
        email: '',
        phone: '',
        website: '',
      },
    },
  },
  errors: [],
  setErrors: notImplemented,
  setPageInfo: notImplemented,

  selectedTemplate: null,
  setSelectedTemplate: notImplemented,
  selectedIndeedProject: null,
  selectedIndeedJob: null,
  setSelectedIndeedProject: notImplemented,
  setSelectedIndeedJob: notImplemented,
  isIndeedReply: false,

  attachments: [],
  setAttachments: notImplemented,

  onContactSuccesful: notImplemented,
  onContactUnsuccessful: notImplemented,
  onSendMessage: notImplemented,

  onRequestChangeType: notImplemented,
};

export const OutreachModalContext = createContext(initialState);
